/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GetUserGachaDatesResponse } from '../../models/get-user-gacha-dates-response';
import { UserServiceGetUserGachaDatesRequest } from '../../models/user-service-get-user-gacha-dates-request';

export interface UserServiceGetUserGachaDates$Params {
  userUuid: string;
      body: UserServiceGetUserGachaDatesRequest
}

export function userServiceGetUserGachaDates(http: HttpClient, rootUrl: string, params: UserServiceGetUserGachaDates$Params, context?: HttpContext): Observable<StrictHttpResponse<GetUserGachaDatesResponse>> {
  const rb = new RequestBuilder(rootUrl, userServiceGetUserGachaDates.PATH, 'post');
  if (params) {
    rb.path('userUuid', params.userUuid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<GetUserGachaDatesResponse>;
    })
  );
}

userServiceGetUserGachaDates.PATH = '/api/v3/gateway/user/{userUuid}/gacha/dates';
